import { InfoOutlined } from '@mui/icons-material'
import React from 'react'
import { Card, Col, Row } from 'reactstrap'
import { KYC_NOTE_VIEW } from '../../../../constant'

const KycViewNote = () => {
  return (
    <>
      <Row>
        <Col xl="12" md="12">
          <Card style={{ backgroundColor: "#E7E4FF" }}>
            <h2 style={{ color: '#7366FF', fontSize: '1rem', margin: '10px' }}><InfoOutlined style={{ fontSize: '1rem', marginBottom: '-3px' }} /> Note</h2>
            <p style={{ fontSize: '0.8rem', lineHeight: '1.4', paddingLeft: '15px',paddingBottom: '15px' }}>
              {KYC_NOTE_VIEW}
            </p>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default KycViewNote
